/* eslint-env browser */
/* global FB */
import { loadScript } from 'dashboard/helper/DOMHelpers';

const runFBInit = () => {
  FB.init({
    appId: window.chatwootConfig.fbAppId,
    xfbml: true,
    version: window.chatwootConfig.fbApiVersion,
    status: true,
  });
};

// The Facebook SDK only finishes its internal bootstrap once it can call
// `window.fbAsyncInit`, so this must be registered before the script loads
// (mirrors the inbox channel's Facebook.vue connect flow).
window.fbAsyncInit = window.fbAsyncInit || runFBInit;

const loadFBsdk = () =>
  loadScript('https://connect.facebook.net/en_US/sdk.js', {
    id: 'facebook-jssdk',
  });

/**
 * Triggers the Facebook Login popup requesting the `ads_read` scope and
 * resolves with the short-lived user access token on success.
 * @returns {Promise<string>}
 */
export function useFacebookAdsLogin() {
  const login = () =>
    new Promise((resolve, reject) => {
      loadFBsdk()
        .then(() => {
          runFBInit();
          FB.login(
            response => {
              if (response.status === 'connected') {
                resolve(response.authResponse.accessToken);
              } else {
                reject(new Error(response.status));
              }
            },
            { scope: 'ads_read' }
          );
        })
        .catch(reject);
    });

  return { login };
}
